import { Router, ActivatedRoute } from '@angular/router';
import { Component, OnInit, Input, EventEmitter, Output, OnChanges } from '@angular/core';
import { InformacionVisitanteModel, InformacionVisitaDetalle } from 'src/app/shared/models/informacionVisitante.model';
import { NgxSpinnerService } from 'ngx-spinner';
import { UrlService } from 'src/app/shared/services/url.service';
import { UrlControl } from 'src/app/shared/models/generic.model';
import { GlobalService } from 'src/app/shared/global.service';
import { AlertService } from 'src/app/shared/services/alert.service';
import { ReporteVisitaModel } from 'src/app/models/reporteVisita.model';
import { ContenedorActivoFijoVisitanteModel } from 'src/app/models/contenedorActivoFijoVisitante.model';
import { ParametrosConsultaActivoFijoVisitante } from 'src/app/models/parametrosConsultaActivoFijoVisitante.model';
import { ConsultaActivoFijoVisitante } from 'src/app/models/consultaActivoFijoVisitante.model';
import { ActivoFijoModel } from 'src/app/models/activoFijo.model';
import { ActivoFijoVisitanteModel } from 'src/app/models/activoFijoVisitante.model';
import { HisActivoFijoVisitanteModel, HisActivoFijoVisitantePK } from 'src/app/models/hisActivoFijoVisitante.model';
import { ConfirmationModalOptions } from 'src/app/shared/models/modal.model';
import { ConstantesService } from 'src/app/shared/services/constantes.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {
  ModalAsociarTarjetaReutilizableComponent
} from './modal-asociar-tarjeta-resutilizable/modal-asociar-tarjeta-reutilizable.component';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { DominiosService } from 'src/app/shared/services/dominios.service';
import { VariablesZonaCompartida } from 'src/app/shared/services/VariablesZonaCompartida';

declare var $: any;


@Component({
  selector: 'app-registro-entrada-visitante',
  templateUrl: './registro-entrada-visitante.component.html',
  styleUrls: ['./registro-entrada-visitante.component.scss']
})
export class RegistroEntradaVisitanteComponent implements OnInit, OnChanges {

  @Output() resultado = new EventEmitter();
  public objetoFichaVisitante: InformacionVisitanteModel;
  public datosvisitantes: any;
  public agendasvisitante: any;
  public nombre: any;
  public tipovc: any;
  public funcionario: any;
  public objetoEntrada: ReporteVisitaModel;
  public ingresoExitoso: boolean;
  public fechaConsulta: string;
  public modalPrintMessage: ConfirmationModalOptions;
  public modalReSendMessage: ConfirmationModalOptions;
  public campos: any;
  public htmlSticker: string;

  public pantalla: string;
  public listaActivosPrincipal;

  public resultadoRegistro: string;

  public parametrosConsultaActivoFijoVisitante: ParametrosConsultaActivoFijoVisitante;
  public consultaActivoFijoVisitante: ConsultaActivoFijoVisitante[] = [];

  constructor(
    private modalService: NgbModal, private spinner: NgxSpinnerService, private urlService: UrlService, private route: ActivatedRoute,
    private global: GlobalService, private alertService: AlertService, private router: Router) {
    this.objetoFichaVisitante = new InformacionVisitanteModel('', '', '', '', '', false, '', '', '', false, 'Ingreso', [], '');
    this.ingresoExitoso = false;
    this.objetoEntrada = this.global.zonaCompartida[VariablesZonaCompartida.OBJETO_VISITA];

    // se construye la fecha
    if (this.objetoEntrada && this.objetoEntrada.agendaVisita) {
      this.fechaConsulta = this.objetoEntrada.agendaVisita.split(' ')[0];
      const fecha = this.fechaConsulta.split('/');
      this.fechaConsulta = fecha[0] + '/' + fecha[1] + '/' + fecha[2];
    }
    this.htmlSticker = ConstantesService.HTML_STICKER;
    this.pantalla = ConstantesService.PANTALLA_INGRESO_SALIDA_VISITANTE_ENTRADA;

    this.inicializarModal();
    this.revisarFoto();
  }


  ngOnInit() {
    this.getDominioTD();
    this.parametrosConsultaActivoFijoVisitante = new ParametrosConsultaActivoFijoVisitante();

    this.parametrosConsultaActivoFijoVisitante.tipoDocumentoVisitante = this.objetoEntrada.tipoIdVisitante;
    this.parametrosConsultaActivoFijoVisitante.numeroDocumentoVisitante = this.objetoEntrada.numeroIdVisitante;
  }

  ngOnChanges() {
    if (this.objetoFichaVisitante) {
      this.modalPrintMessage.disabled = !this.objetoFichaVisitante.foto ||
        this.objetoFichaVisitante.ingresoVehiculo == null || this.ingresoExitoso;
    }
  }
  // damunoz
  // 09/06/2019
  // Metodo que setea los datos faltantes para registro de activo fijo de un visitante
  // handlerActivos(event: ContenedorActivoFijoVisitanteModel) {
  //   if (event.activoFijoVisitanteDTO) {
  //     event.activoFijoVisitanteDTO.tipoDocVisitante = this.objetoEntrada.tipoIdVisitante;
  //     event.activoFijoVisitanteDTO.numDocVisitante = this.objetoFichaVisitante.numeroDocumento;
  //     event.hisActivoFijoVisitanteDTO.idVisita = this.objetoEntrada.idVisita;
  //    }
  //   }
  handlerActivos(event: ContenedorActivoFijoVisitanteModel) {
    if (event.activoFijoVisitanteDTO) {
      event.activoFijoVisitanteDTO.tipoDocVisitante = this.objetoEntrada.tipoIdVisitante;
      event.activoFijoVisitanteDTO.numDocVisitante = this.objetoFichaVisitante.numeroDocumento;
      event.hisActivoFijoVisitanteDTO.idVisita = this.objetoEntrada.idVisita;
    }
    this.registrarActivoFijoVisitante(event);
  }

  getConfirmationModalResponse(event) {
    if (event[0] === true) {
      this.guardarIngresoVisitante();
    }
  }

  getConfirmationModalAux(event) {
    if (event[0] === true) {
      this.imprimir();
    }
  }

  inicializarModal() {
    this.modalPrintMessage = new
      ConfirmationModalOptions('Confirmación', '¿Está seguro de registrar entrada y de imprimir sticker?'
        , 'Si', 'No', 'fas fa-print', !this.objetoFichaVisitante.foto ||
        this.objetoFichaVisitante.ingresoVehiculo == null || this.ingresoExitoso, false, 'Imprimir Sticker', undefined, 'btn-secondary');
    this.modalReSendMessage = new
      ConfirmationModalOptions('Exito', 'Se registró entrada exitosamente', 'Reimprimir', 'Cerrar', ''
        , false, false, 'Reimprimir', undefined, 'btn-auxiliar');
  }

  revisarFoto() {
    if (this.objetoFichaVisitante) {
      this.modalPrintMessage.disabled = !this.objetoFichaVisitante.foto ||
        this.objetoFichaVisitante.ingresoVehiculo == null || this.ingresoExitoso;
    }
    setTimeout(() => {
      this.revisarFoto();
    }, 1000);
    // this.registrarActivoFijoVisitante(event);
  }

  // damunoz
  // 13/06/2019
  // metodo que obtiene el elemento seleccionado para registro desde el componente hijo de activos recientes
  handlerActivoSeleccionado(event) {
    const activoFijoVisitanteDTO = new ActivoFijoVisitanteModel();
    const activoPK = new HisActivoFijoVisitantePK();
    const hisActivoFijoVisitanteDTO = new HisActivoFijoVisitanteModel(activoPK);
    const resp: ContenedorActivoFijoVisitanteModel =
      new ContenedorActivoFijoVisitanteModel(activoFijoVisitanteDTO, hisActivoFijoVisitanteDTO);
    if (event) {
      // mapeo para actualizacion de activo fijo
      resp.activoFijoVisitanteDTO.idActivoFijoVisitante = event.Activo.idActivo;
      resp.activoFijoVisitanteDTO.estado = DominiosService.ESTADO_ACTIVO_FIJO_INGRESADO;
      // creacion de nuevo historico de activo fijo
      //resp.hisActivoFijoVisitanteDTO.hisActivoFijoVisitantePK.fechaIngresoActivo = new Date();
      resp.hisActivoFijoVisitanteDTO.idVisita = this.objetoEntrada.idVisita;
      resp.hisActivoFijoVisitanteDTO.sede = event.Activo.sede;
    }
    this.registrarActivoFijoVisitante(resp);
  }

  // damunoz
  // 09/06/2019
  // Metodo que registra un nuevo activo fijo de un visitante
  registrarActivoFijoVisitante(event: ContenedorActivoFijoVisitanteModel) {
    this.spinner.show();
    const serviceProvider = 'registrarActivoFijoVisitante';
    const url = this.urlService.getUrl(new UrlControl(serviceProvider, null, null), this.urlService.hostAPI_ACCVIS);
    this.global.postGenerico(url, event).subscribe(
      data => {
        this.alertService.generateAlertSuccess(ConstantesService.REGISTRO_ACTIVO_FIJO_VISITANTE_EXISTOSO, '', '');
        this.consultarActivosFijos();
      }, (err: any) => {
        this.catchException('No es posible realizar el registro de activo fijo');
      }
    );
    this.spinner.hide();
  }



  public getDominioTD() {
    this.spinner.show();
    const serviceProvider = 'ObtenerDominio';
    const queryParams: Array<[string, string]> = new Array<[string, string]>();
    queryParams.push(['filterBy=detalleDominioPK.nombreDominio', 'TipoIdentificacion']);
    queryParams.push(['detalleDominioPK.nombreDominio', 'TipoVehiculo']);
    const url = this.urlService.getUrl(new UrlControl(serviceProvider, null, queryParams), this.urlService.hostAPI_ACCVIS);

    this.global.getGenerico(url).subscribe(
      data => {
        this.nombre = data;
        this.getDominioTV();
      }, err => {
        this.catchException(err);
      }
    );
  }

  public getDominioTV() {

    const serviceProvider = 'ObtenerDominio';
    const queryParams: Array<[string, string]> = new Array<[string, string]>();
    queryParams.push(['filterBy=detalleDominioPK.nombreDominio', 'TipoVehiculo']);
    const url = this.urlService.getUrl(new UrlControl(serviceProvider, null, queryParams), this.urlService.hostAPI_ACCVIS);

    this.global.getGenerico(url).subscribe(
      data => {
        this.tipovc = data;

        this.getInformacionVisitante();
        // this.obtenerVisitante();
      }, err => {
        this.catchException(err);
      }
    );
  }

  // fromero
  // metodo de redirección a página de consultas
  // 15/05/2019
  regresarListaAgendas() {
    this.global.zonaCompartida[VariablesZonaCompartida.OBJETO_VISITA] = undefined;
    this.router.navigate(['/main']);
  }

  // fromero
  // método de consulta de información de visitante Básica y agendas del día
  // 13/05/2019
  getInformacionVisitante() {
    this.spinner.show();
    const serviceProvider = 'ObetenerInformacionAgendasVisitante';
    const queryParams: Array<[string, string]> = new Array<[string, string]>();

    queryParams.push(['tipoDocumento', this.objetoEntrada.tipoIdVisitante]);
    queryParams.push(['numeroDocumento', this.objetoEntrada.numeroIdVisitante]);
    queryParams.push(['fechaConsulta', this.fechaConsulta]);
    const url = this.urlService.getUrl(new UrlControl(serviceProvider, null, queryParams), this.urlService.hostAPI_ACCVIS);

    this.global.postGenerico(url).subscribe(
      data => {
        this.objetoFichaVisitante = data[0];
        this.objetoFichaVisitante.numeroDocumento = this.objetoEntrada.numeroIdVisitante;
        this.objetoFichaVisitante.tipoVisitante = this.objetoEntrada.tipoVisitante;
        this.objetoFichaVisitante.pantalla = 'Ingreso';
        this.objetoFichaVisitante.codigoTipoDocumento = this.objetoEntrada.tipoIdVisitante;
        //        this.objetoFichaVisitante.tipoVisitante =this.objetoEntrada.estadoVisitante;
        this.consultarActivosFijos();
        this.inicializarModal();
        this.spinner.hide();
      }, err => {
        this.catchException(err);
      }
    );
  }



  // fromero
  // 20/05/2019
  // Método para envío de petición para registro de ingreso de visitante

  public guardarIngresoVisitante() {

    this.spinner.show();
    const serviceProvider = 'RegistrarIngresoVisitante';
    const url = this.urlService.getUrl(new UrlControl(serviceProvider, null, null), this.urlService.hostAPI_ACCVIS);

    this.global.postGenerico(url, this.objetoFichaVisitante).subscribe(
      data => {
        this.campos = data;
        this.imprimir();
        this.ingresoExitoso = true;
        $('.btn-auxiliar').click();
        this.spinner.hide();
      }, err => {
        this.catchException(err);
      }
    );
  }

  // damunoz
  // 09/06/2019
  // Método para obtener activos fijos de un visitante
  public consultarActivosFijos() {
    this.listaActivosPrincipal = undefined;
    const listaTemp = [];
    const serviceProvider = 'ConsultaActivosFijosVisitante';
    const url = this.urlService.getUrl(new UrlControl(serviceProvider, null, null), this.urlService.hostAPI_ACCVIS);
    this.parametrosConsultaActivoFijoVisitante.tipoDocumentoVisitante = this.objetoEntrada.tipoIdVisitante;
    this.parametrosConsultaActivoFijoVisitante.numeroDocumentoVisitante = this.objetoFichaVisitante.numeroDocumento;
    this.global.postGenerico(url, this.parametrosConsultaActivoFijoVisitante).subscribe(
      (data: ConsultaActivoFijoVisitante[]) => {

        if (data.length != 0) {
          this.consultaActivoFijoVisitante = data;
          this.objetoFichaVisitante.ingresoActivo = data.length > 0;

          if (this.consultaActivoFijoVisitante.length === 1 &&
            this.consultaActivoFijoVisitante[0].numeroSerial === '' &&
            this.consultaActivoFijoVisitante[0].marca === '' &&
            this.consultaActivoFijoVisitante[0].numeroDeIngresos === 0) {
            this.consultaActivoFijoVisitante = [];
          } else {
            this.consultaActivoFijoVisitante.forEach(elemento => {
              const activo: ActivoFijoModel = new ActivoFijoModel('', '', '', '', '', '', '', '', '', '', '', '', '', '', '');
              activo.descripcion = elemento.descripcion;
              activo.marca = elemento.marca;
              activo.observaciones = elemento.observaciones;
              activo.serialActivoFijo = elemento.numeroSerial;
              activo.idActivo = elemento.idActivoFijovisitante;
              activo.numeroIngresos = elemento.numeroDeIngresos;
              activo.fechaUltimoIngreso = elemento.fechaUltimoIngreso;
              activo.estado = elemento.estado;
              activo.clasificacion = 'PROPIO';
              activo.pantallaOrigen = ConstantesService.PANTALLA_INGRESO_SALIDA_VISITANTE_ENTRADA;
              listaTemp.push(activo);
            });
          }
          this.listaActivosPrincipal = listaTemp;
        } else {
          this.alertService.generateAlertError('No existen resultados para la búsqueda del activo', '');
        }

        this.spinner.hide();
      }, (err: any) => {
        this.catchException('No es posible realizar la consulta de activos fijos');
      });
  }

  /**
   * Método que reemplaza los valores de la plantilla por la información obtenida
   * @author jnmartinez
   */
  reemplazarCampos() {
    const nombreAtributos = Object.getOwnPropertyNames(this.campos);
    for (const nombre of nombreAtributos) {
      this.htmlSticker = this.htmlSticker.replace('[' + nombre + ']', this.campos[nombre]);
    }
  }

  /**
   * Método que realiza la impresión de la plantilla
   * @author jnmartinez
   */
  imprimir() {
    this.htmlSticker = ConstantesService.HTML_STICKER;
    this.reemplazarCampos();
    // tslint:disable: no-string-literal
    window.frames['print_frame'].document.body.innerHTML = this.htmlSticker;
    window.frames['print_frame'].window.focus();
    setTimeout(() => {
      window.frames['print_frame'].window.print();
      window.frames['print_frame'].document.body.innerHTML = '';
    }, 100);
  }


  handlerFiltroBusqueda(event) {
    this.spinner.show();
    this.parametrosConsultaActivoFijoVisitante.numeroSerial = event;
    this.consultarActivosFijos();
  }

  /**
   * Método que abre un modal para ingresar el codigo de la tarjeta
   * @author jnmartinez
   * @return void
   */
  abrirModalTarjeta() {
    const modalRef = this.modalService.open(ModalAsociarTarjetaReutilizableComponent, { centered: true });
    modalRef.componentInstance.data = this.objetoFichaVisitante; // Objeto que se envìa al modal para ediciòn
    modalRef.result.then((result) => {
      if (result.filtro) {
        this.objetoFichaVisitante.codigoTarjeta = result.filtro; // asigna el código de tarjeta ingresado
        this.guardarIngresoVisitanteTarjeta(result.filtro);
      }
    });
  }

  retomarVisita() {
    const url = this.urlService.getUrl(new UrlControl('retomarVisita', null, null), this.urlService.hostAPI_ACCVIS);
    this.global.post(url, this.objetoEntrada).subscribe(
      (data: any) => {
        this.alertService.generateAlertSuccess('Se registró entrada exitosamente', '');
        this.global.zonaCompartida[VariablesZonaCompartida.OBJETO_VISITA] = undefined;
        this.router.navigate(['/main']);
      }, error => this.catchException(error));
  }

  catchException(error) {
    this.spinner.hide();
    if (error && error.error) {
      this.alertService.generateAlertError(error.error.message, 'Error');
    } else {
      this.alertService.generateAlertError('Se presento un error registrando el ingreso', 'Error');
    }
  }

  /**
   * fromero
   * metodo de registro de ingreso con  tarjeta  
   * @param codigo 
   */
  guardarIngresoVisitanteTarjeta(codigo) {
    this.spinner.show();
    const serviceProvider = 'RegistrarIngresoVisitanteTarjeta';
    const url = this.urlService.getUrl(new UrlControl(serviceProvider, null, null), this.urlService.hostAPI_ACCVIS);

    this.global.postGenerico(url, this.objetoFichaVisitante).subscribe(
      data => {
        this.campos = data;
        this.spinner.hide();
        this.alertService.generateAlertSuccess('Se registró entrada exitosamente', '');
        this.regresarListaAgendas();
      }, err => {
        this.catchException('Ocurrio un error al registrar el ingreso');
        this.abrirModalTarjeta();
      }
    );
  }

}
